import React, { createContext, useContext, useState } from 'react';

type PageHeadingContextType = {
    pageHeading: string | null;
    setPageHeading: (heading: string | null) => void;
};

const PageHeadingContext = createContext<PageHeadingContextType | undefined>(undefined);

export const PageHeadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [pageHeading, setPageHeading] = useState<string | null>(null);

    return (
        <PageHeadingContext.Provider value={{ pageHeading, setPageHeading }}>
            {children}
        </PageHeadingContext.Provider>
    );
};

export const usePageHeading = () => {
    const context = useContext(PageHeadingContext);
    if (!context) {
        throw new Error('usePageHeading must be used within a PageHeadingContext');
    }
    return context;
};
